import cx from "classnames";
import React from "react";

import styles from "./PricemaniaWidget.mscss";

interface OwnProps {
    id: string;
    maxHeight?: number;
}

type Props = OwnProps;

export default class PricemaniaWidget extends React.PureComponent<Props> {
    private scriptContainer: React.RefObject<HTMLDivElement> = React.createRef();

    public appendScript(id) {
        const scriptTag = document.createElement("script");
        scriptTag.setAttribute("async", "true");
        scriptTag.setAttribute("class", `pmw-script-class-${id}`);
        scriptTag.src = `https://public.pricemania.sk/v1/widget/product/script.js?w_id=${id}`;
        this.scriptContainer.current.appendChild(scriptTag);
    }

    public removeScript(id) {
        const elements = this.scriptContainer.current.getElementsByClassName(
            `pmw-script-class-${id}`,
        );
        if (elements) {
            this.scriptContainer.current.removeChild(elements[0]);
        }
    }

    public componentDidMount() {
        this.appendScript(this.props.id);
    }

    public componentWillUnmount() {
        this.removeScript(this.props.id);
    }

    public componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.removeScript(prevProps.id);
            this.appendScript(this.props.id);
        }
    }

    public render() {
        const { id, maxHeight } = this.props;
        return (
            id && (
                <div
                    ref={this.scriptContainer}
                    className={cx(
                        styles.PricemaniaWidget,
                        maxHeight && styles[`PricemaniaWidget__withMaxHeight`],
                    )}
                    style={
                        maxHeight
                            ? {
                                  maxHeight,
                              }
                            : null
                    }
                >
                    <div className="pma-widget" data-id={id} />
                    {maxHeight && <div className={styles.PricemaniaWidget__mask} />}
                </div>
            )
        );
    }
}
